<template>
  <div
    v-loading="loading"
    class="app-main-content"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(170,170,170,0.5)"
  >
    <div class="grid-view">
      <!--      <div v-if="isShow" class="main-content">-->
      <!--        &lt;!&ndash; 暴露给子应用的扩展点，isshow=true时，显示子应用，子应用的地址后续需要改为动态从主应用获取 &ndash;&gt;-->
      <!--        -->
      <!--      </div>-->
      <div class="main-content">
        <search-item
          ref="searchItem"
          config-module="302"
          :custom-sim-query-placeholder="$t('CargoMsg.Cargo_PlsInput')+' : '+$t('SeaExport.OrderNo2')"
          :custom-search-items="customSearchItems"
          no="1"
          @click-more="value=>{isAdvancedQuery=value}"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <el-button
              v-permission="['button_fmRailwayBoxTube_buyContainer']"
              no="BuyContainer"
              type="primary"
              @click="buyContainerClickHandler"
            >{{ $t('RailwayExport.BuyContainer') }}</el-button>
            <el-button
              v-permission="['button_fmRailwayBoxTube_sellContainer']"
              no="SellContainer"
              type="primary"
              @click="sellContainerClickHandler"
            >{{ $t('RailwayExport.SellContainer') }}</el-button>
            <el-button
              v-permission="['button_fmRailwayBoxTube_rentContainer']"
              no="RentContainer"
              type="primary"
              @click="rentContainerClickHandler"
            >{{ $t('RailwayExport.RentContainer') }}</el-button>
            <el-button
              v-permission="['button_fmRailwayBoxTube_editContainer']"
              no="Edit"
              type="primary"
              @click="editClickHandler"
            >{{ $t('RailwayExport.Edit') }}</el-button>
            <el-button
              v-permission="['button_fmRailwayBoxTube_deleteContainer']"
              no="Delete"
              type="primary"
              @click="deleteClickHandler"
            >{{ $t('RailwayExport.Delete') }}</el-button>
            <micro-app
              v-if="isShow"
              name="child-vue2"
              :url="$store.getters.frontEndPluginUrl+'/'"
              router-mode="pure"
              destroy
              :data="getSelectData()"
              @datachange="handleDataChange"
            />
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="170002"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            no="2"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination config-module="170002" :total="total" :page.sync="pageNum" :limit.sync="pageSize" no="3" @pagination="toQuery" />
        </div>
      </div>
    </div>
    <!-- 买箱弹窗 -->
    <box-operation-dialog
      :visible.sync="boxOperationDialog.visible"
      :title="boxOperationDialog.title"
      :order-type="boxOperationDialog.orderType"
      :is-edit="boxOperationDialog.isEdit"
      :railway="boxOperationDialog.railway"
      no="4"
      @resultFunction="toQuery"
    />
    <!-- 卖箱弹窗 -->
    <selling-box-dialog
      :visible.sync="sellingBoxDialog.visible"
      :railway-list="sellingBoxDialog.railwayList"
      no="5"
      @resultFunction="toQuery"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import boxOperationDialog from '@/views/cargo/v0/RailwayExport/components/booking/boxOperationDialog'
import sellingBoxDialog from '@/views/cargo/v0/RailwayExport/components/fmRailwayBoxTube/sellingBoxDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as BoxTubeConstants from '@/class/cargo/model/parameters/BoxTubeConstants'
import { railwayContainerOrderAdvancedQuery, deleteOrder } from '@/api/railwayExport/railwayContainerOrder'

export default {
  name: 'FmRailwayBoxTube',
  components: { searchItem, boxOperationDialog, sellingBoxDialog },
  data() {
    return {
      loading: false,
      oldIsAdvanceQuery: false, // 记录上一次操作是否为高级查询
      isAdvancedQuery: false, // 是否为高级查询
      customSearchItems: [{
        action: AdvancedSearchField.UPDATE_ACTION,
        itemType: 'select',
        itemCondition: [],
        defaultConditionVal: '',
        fieldType: 'FIELD_RADIO',
        itemName: 'RCO.IF_SETTLEMENT',
        itemLabel: 'RailwayExport.WhetherSettlement',
        itemValue: false,
        defaultSelected: 0,
        selected: 0,
        dropdownDataRef: 'RadioStatusConstants.YES_NO_TYPES',
        dataCacheKey: 'local_cache_RadioStatusConstants$YES_NO_TYPES',
        valueExpression: '',
        headers: [],
        fields: [],
        tagValue: '',
        tagName: '',
        lock: false,
        defaultValue: false,
        isShow: false
      }],
      simpleFilter: {
        conditions: null,
        branchId: 0
      },
      complexFilter: {
        conditions: null,
        branchId: 0
      },
      pageNum: 1,
      pageSize: 50,
      total: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: { componentParent: this }
      },
      columnDefs: [
        {
          headerName: '',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 55,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('RailwayExport.OrderNo'),
          field: 'orderNo',
          width: 180
        }, {
          headerName: this.$t('RailwayExport.BoxOwner'),
          field: 'sellerName',
          width: 180
        }, {
          headerName: this.$t('RailwayExport.Buyer'),
          field: 'buyerName',
          width: 130
        }, {
          headerName: this.$t('RailwayExport.OrderType'),
          field: 'orderType',
          width: 130,
          valueFormatter: params => {
            switch (params.value) {
              case 1:
                return this.$t('RailwayExport.BuyingContainer')
              case 2:
                return this.$t('RailwayExport.SellingContainer')
              case 3:
                return '租箱'
              default:
                return ''
            }
          }
        }, {
          headerName: this.$t('RailwayExport.Amount'),
          field: 'amount',
          width: 130
        }, {
          headerName: this.$t('RailwayExport.CurrencyCode'),
          field: 'currencyCode',
          width: 130
        }, {
          headerName: this.$t('RailwayExport.WhetherSettlement'),
          field: 'isIfSettlement',
          width: 130,
          valueFormatter: params => {
            return params.value ? this.$t('RailwayExport.Yes') : this.$t('RailwayExport.No')
          }
        }, {
          headerName: this.$t('RailwayExport.SettlingTime'),
          field: 'settlementDate',
          width: 180
        }, {
          headerName: this.$t('RailwayExport.BuyTime'),
          field: 'buyerDate',
          width: 180,
          valueFormatter: params => {
            return ColumnUtils.dateColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('RailwayExport.SellerDate'),
          field: 'sellerDate',
          width: 180,
          valueFormatter: params => {
            return ColumnUtils.dateColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('RailwayExport.RentDate'),
          field: 'rentDate',
          width: 180,
          valueFormatter: params => {
            return ColumnUtils.dateColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('RailwayExport.ReturnDate'),
          field: 'returnDate',
          width: 180,
          valueFormatter: params => {
            return ColumnUtils.dateColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('RailwayExport.OperationTime'),
          field: 'dateCreated',
          width: 180
        }, {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'railwayContainerNos',
          colId: 'railwayContainerNos',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remarks',
          colId: 'remarks',
          width: 150,
          hide: true
        }
      ],
      rowData: [],
      selectedNode: null,
      gridApi: null,
      boxOperationDialog: {
        visible: false,
        title: '',
        orderType: 0,
        isEdit: false,
        railway: null
      },
      sellingBoxDialog: {
        visible: false,
        railwayList: []
      }
    }
  },
  computed: {
    filter() {
      return this.isAdvancedQuery ? this.complexFilter : this.simpleFilter
    }
  },
  created() {
    this.toAdvancedQuery([])
    // 如果当前租户是88，则显示子应用
    if (this.$store.getters.tenantId === 889) {
      this.isShow = true
    }
  },
  methods: {
    // 查询[简单查询/高级查询]
    toQuery() {
      if (!this.filter.conditions) {
        return
      }
      if (this.isAdvancedQuery !== this.oldIsAdvanceQuery) {
        this.pageNum = 1
        this.oldIsAdvanceQuery = this.isAdvancedQuery
      }
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 简单查询
    toSimpleQuery(keyword) {
      let data
      if (typeof keyword !== 'undefined') {
        data = new AdvancedSearchOption(null, 'RCO.ORDER_NO', keyword).formatObj2Json()
      }
      this.toAdvancedQuery(data)
    },
    // 高级查询
    toAdvancedQuery(data) {
      const filter = this.filter
      if (typeof data !== 'undefined') {
        filter.conditions = data
        this.pageNum = 1
      }
      filter.branchId = this.$store.getters.currentOfficeId
      filter.pageNum = this.pageNum
      filter.pageSize = this.pageSize
      this.loading = true
      railwayContainerOrderAdvancedQuery(filter).then(res => {
        this.rowData = res.data.list
        this.pageNum = res.data.pageNum
        this.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
      }).finally(() => {
        this.loading = false
      })
    },
    buyContainerClickHandler() {
      this.boxOperationDialog.title = this.$t('RailwayExport.BuyContainer')
      this.boxOperationDialog.orderType = BoxTubeConstants.BUYING_BOXES.code
      this.boxOperationDialog.isEdit = false
      this.boxOperationDialog.railway = null
      this.boxOperationDialog.visible = true
    },
    sellContainerClickHandler() {
      const rows = this.gridApi.getSelectedRows()
      let currencyCode = ''
      for (const row of rows) {
        if (row.orderType !== BoxTubeConstants.BUYING_BOXES.code) {
          this.$message.warning(this.$t('Message.OnlyBuyCaseOrderBoxCanBeSold'))
          return
        }
        if (currencyCode === '') {
          currencyCode = row.currencyCode
        } else if (currencyCode !== row.currencyCode) {
          this.$message.warning(this.$t('Message.ChoiceCaseSell'))
          return
        }
      }
      // 勾选后，进入新卖箱页面
      if (rows.length > 0) {
        this.sellingBoxDialog.railwayList = rows
        this.sellingBoxDialog.visible = true
      } else {
        this.boxOperationDialog.title = this.$t('RailwayExport.SellContainer')
        this.boxOperationDialog.orderType = BoxTubeConstants.SELLING_BOX.code
        this.boxOperationDialog.isEdit = false
        this.boxOperationDialog.railway = null
        this.boxOperationDialog.visible = true
      }
    },
    rentContainerClickHandler() {
      this.boxOperationDialog.title = this.$t('RailwayExport.RentContainer')
      this.boxOperationDialog.orderType = BoxTubeConstants.RENT_BOX.code
      this.boxOperationDialog.isEdit = false
      this.boxOperationDialog.railway = null
      this.boxOperationDialog.visible = true
    },
    editClickHandler() {
      if (!this.selectedNode) {
        this.$message.warning(this.$t('RailwayExport.PleaseTheContainerToEdit'))
        return
      }
      const railway = this.selectedNode.data
      this.boxOperationDialog.title = this.$t('RailwayExport.EditOrderInformation')
      this.boxOperationDialog.orderType = railway.orderType
      this.boxOperationDialog.isEdit = true
      this.boxOperationDialog.railway = railway
      this.boxOperationDialog.visible = true
    },
    deleteClickHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('RailwayExport.PleaseTheContainerToDelete'))
        return
      }
      this.$confirm(this.$t('RailwayExport.AreWantToDeleteInformation'), this.$t('RailwayExport.PromptInformation'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        this.loading = true
        deleteOrder(Array.from(rows, p => p.uuid)).then(res => {
          if (res.data === 0) {
            this.$message.success(this.$t('Message.DeleteSuccessfully'))
            this.toQuery()
          } else {
            this.$message.warning(this.$t('RailwayExport.DeletingOrderContainsOccupiedContainers'))
          }
        }).finally(() => {
          this.loading = false
        })
      }).catch(() => {})
    },
    getSelectData() {
      if (this.selectedNode) {
        const railway = this.selectedNode.data
        return railway
      }
    },
    handleDataChange(e) {
      console.log(data)
      const data = e.detail.data
      if (data.type === 'delete') {
        this.deleteClickHandler()
      } else if (data.type === 'reset') {
        this.toQuery()
      }
    }
  }
}
</script>
